import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getGoalById } from "../utils";
import { CircularProgress } from "@mui/material";

const GoalDetail = () => {
  const location = useLocation();
  const { goalIdk } = location.state || {};

  const [goalId, setGoalId] = useState(goalIdk || "");
  const [loading, setLoading] = useState(null);
  const [goal, setGoal] = useState(null);

  useEffect(() => {
    if (goalId) {
      fetchGoal(goalId);
    }
  }, [goalId]);

  const fetchGoal = async (goalId) => {
    setLoading(true);
    try {
      const goalDetails = await getGoalById(goalId);
      setGoal(goalDetails);
    } catch (error) {
      console.error("Error fetching goal:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="py-16 px-5">
      {loading ? (
        <div className="flex justify-center items-center">
          <CircularProgress />
        </div>
      ) : (
        <>
          <>
            {goal && (
              <p className="text-2xl font-bold text-color-8  mt-5">
                Goal Detail:
              </p>
            )}

            {goal ? (
              <div>
                <p className="text-base font-semibold text-color-7 mt-4">
                  Goal Title: {goal?.title || ""}
                </p>
                <p className="text-base font-semibold text-color-7 mt-4">
                  Progress: {goal?.progress || "0"}%
                </p>

                <p className="text-base font-semibold text-color-7 mt-4 flex flex-row">
                  Description:{" "}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: goal?.detail || "No details available",
                    }}
                  />
                </p>
              </div>
            ) : null}
          </>
        </>
      )}
    </div>
  );
};

export default GoalDetail;
